import { CardWrapper } from '@/components/card-wrapper';
import { Button } from '@/components/button';
import styles from './error-layout.module.css';
import { useTranslation } from '@/contexts/i18n-context';
import { BrokenLinkSvg } from './svgs/broken-link';
import { ReactNode } from 'react';

interface ErrorLayoutProps {
  title: string;
  description: ReactNode;
  withoutButton?: boolean;
}

export function ErrorLayout({ title, description, withoutButton = false }: ErrorLayoutProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <CardWrapper className={styles.wrapper}>
        <BrokenLinkSvg ariaLabel={title} />
        <h1 className="h3">{title}</h1>
        <p className={styles.text}>{description}</p>
        {!withoutButton && (
          <Button className={styles.actionButton} fullWidth as="a" to="/" variant="filled">
            {t('common.backToHome')}
          </Button>
        )}
      </CardWrapper>
    </div>
  );
}
